/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CableTraySystemComponent } from './cable-tray-system.component';
import { DxSelectBoxModule, DxButtonModule } from 'devextreme-angular';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [CableTraySystemComponent],
  imports: [CommonModule, DxSelectBoxModule, DxButtonModule, FormsModule],
  exports: [CableTraySystemComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CableTraySystemModule {}
